import React from "react";

const About = () => {

    return (
        <div  style={{marginTop:"100px",marginBottom:"-80px", marginLeft:"20px"}}>
            About
        </div>
    );

}
export default About;